export default class Tickertape extends HTMLElement {
	connectedCallback() {
		const items = this.querySelector("[data-items]");
		const track = this.querySelector("[data-track]");
		const punctuationEl = this.querySelector("[data-punctuation]");
		const punctuationSource = punctuationEl ? [...punctuationEl.children] : [];

		if (!items || !track) return;

		// Inject punctuation after each original item (optional — only if provided)
		if (punctuationSource.length) {
			[...track.children].forEach((item, index) => {
				const clone = punctuationSource[index % punctuationSource.length].cloneNode(true);
				item.after(clone);
			});
		}

		// Snapshot one "set": original items + their injected punctuation
		const set = [...track.children].map(el => el.cloneNode(true));

		// Fill the track to ~3000px (one half of our 6000px target).
		// --itemWidth is set on <ticker-tape> in liquid (default 240px).
		const itemWidth = parseInt(getComputedStyle(this).getPropertyValue('--itemWidth')) || 240;
		const hasPunctuation = punctuationSource.length > 0;
		const itemCount = hasPunctuation ? set.length / 2 : set.length;
		const setWidth = itemCount * (itemWidth + (hasPunctuation ? 48 + 32 : 32)); // item + optional punct + gap-8
		const setsNeeded = Math.max(1, Math.ceil(3000 / setWidth));

		// We already have 1 set; append more until we reach setsNeeded
		for (let i = 1; i < setsNeeded; i++) {
			set.forEach(el => track.appendChild(el.cloneNode(true)));
		}

		// Clone all current children to create the second half.
		// track now has 2 × setsNeeded copies → -50% of data-items width = exactly the first half.
		[...track.children].forEach(el => track.appendChild(el.cloneNode(true)));

		// Set duration based on first-half pixel width at a fixed 200px/sec scroll rate.
		// This gives a consistent feel regardless of screen size or block count.
		const firstHalfWidth = setsNeeded * setWidth;
		const movementPxPerSec = 50;
		items.style.setProperty('--duration', `${firstHalfWidth / movementPxPerSec}s`);
	}
}
